export const Colors = {
  dark: {
    main: "#dc2626",
    background: "#27274D",
  },
};

export const ProjectTypes = {
  WORK: "Work",
  SCHOOL: "School",
  PERSONAL: "Personal",
};

export const StatusTypes = {
  NOTSTARTED: "Not Started",
  INPROGRESS: "In Progress",
  COMPLETED: "Completed",
};

export const TaskTemplate = {
  _ID: "",
  _Title: "",
  _Status: StatusTypes.NOTSTARTED,
  _TimeWorkedOn: {
    _Hours: 0,
    _Minutes: 0,
  },
  _Sessions: []
};

export const SessionTemplate = {
  _ID: "",
  _StartedOn: "",
  _Breaks: [],
  _TimeWorkedOn: {
    _Hours: 0,
    _Minutes: 0,
  },
}

export const ProjectTemplate = {
  _Name: "",
  _ID: "",
  _Type: "",
  _Starred: false,
  _Tasks: [],
  _Progress: {
    _Percentage: 0,
    _TimeWorkedOn: {
      _Hours: 0,
      _Minutes: 0,
    },
    _Tasks: {
      _Done: 0,
      _All: 0,
    },
  },
};


export const ProjectData = [
  {
    _Name: "Phonebook",
    _ID: 1,
    _Type: ProjectTypes.WORK,
    _Starred: true,
    _Tasks: [
      {
        _ID: "1",
        _Title: "Implement Tasks CRUD",
        _TimeWorkedOn: {
          _Hours: 1,
          _Minutes: 20,
        },
        _CreatedOn: "19/11/2021",
        _StartedOn: "12/12/2021",
        _DueTo: "02/01/2022",
        _Status: StatusTypes.INPROGRESS,
        _Sessions: [
          {
            _ID: "1",
            _StartedOn: "04/01/2022",
            _Breaks: [{ _ID: "1", _StartedAt: "45 min", _LastedFor: "15 min" }],
            _TimeWorkedOn: {
              _Hours: 0,
              _Minutes: 30,
            },
          },
          {
            _ID: "2",
            _StartedOn: "04/01/2022",
            _Breaks: [{ _ID: "1", _StartedAt: "45 min", _LastedFor: "15 min" }],
            _TimeWorkedOn: {
              _Hours: 0,
              _Minutes: 30,
            },
          },
          {
            _ID: "3",
            _StartedOn: "04/01/2022",
            _Breaks: [{ _ID: "1", _StartedAt: "45 min", _LastedFor: "15 min" }],
            _TimeWorkedOn: {
              _Hours: 0,
              _Minutes: 20,
            },
          },
        ],
      },
      {
        _ID: "2",
        _Title: "Complete Task form logic",
        _TimeWorkedOn: {
          _Hours: 2,
          _Minutes: 5,
        },
        _CreatedOn: "19/11/2021",
        _StartedOn: "12/12/2021",
        _DueTo: "02/01/2022",
        _Status: StatusTypes.INPROGRESS,
        _Sessions: [
          {
            _ID: "1",
            _StartedOn: "04/01/2022",
            _Breaks: [{ _ID: "1", _StartedAt: "45 min", _LastedFor: "15 min" }],
            _TimeWorkedOn: {
              _Hours: 1,
              _Minutes: 5,
            },
          },
          {
            _ID: "2",
            _StartedOn: "04/01/2022",
            _Breaks: [{ _ID: "1", _StartedAt: "45 min", _LastedFor: "15 min" }],
            _TimeWorkedOn: {
              _Hours: 1,
              _Minutes: 0,
            },
          },
        ],
      },
      {
        _ID: "3",
        _Title: "Add login authentication",
        _TimeWorkedOn: {
          _Hours: 1,
          _Minutes: 10,
        },
        _CreatedOn: "19/11/2021",
        _StartedOn: "12/12/2021",
        _DueTo: "02/01/2022",
        _Status: StatusTypes.COMPLETED,
        _Sessions: [
          {
            _ID: "3",
            _StartedOn: "04/01/2022",
            _Breaks: [{ _ID: "1", _StartedAt: "45 min", _LastedFor: "15 min" }],
            _TimeWorkedOn: {
              _Hours: 1,
              _Minutes: 10,
            },
          },
        ],
      },
      {
        _ID: "4",
        _Title: "Add refresh token logic",
        _TimeWorkedOn: {
          _Hours: 0,
          _Minutes: 20,
        },
        _CreatedOn: "19/11/2021",
        _StartedOn: "12/12/2021",
        _DueTo: "02/01/2022",
        _Status: StatusTypes.COMPLETED,
        _Sessions: [
          {
            _ID: "3",
            _StartedOn: "04/01/2022",
            _Breaks: [{ _ID: "1", _StartedAt: "45 min", _LastedFor: "15 min" }],
            _TimeWorkedOn: {
              _Hours: 0,
              _Minutes: 20,
            },
          },
        ],
      },
      {
        _ID: "5",
        _Title: "Add logout button",
        _TimeWorkedOn: {
          _Hours: 0,
          _Minutes: 0,
        },
        _CreatedOn: "19/11/2021",
        _StartedOn: "12/12/2021",
        _DueTo: "02/01/2022",
        _Status: StatusTypes.NOTSTARTED,
        _Sessions: [
        ],
      },
      {
        _ID: "6",
        _Title: "Add phonebook edit form",
        _TimeWorkedOn: {
          _Hours: 0,
          _Minutes: 47,
        },
        _CreatedOn: "19/11/2021",
        _StartedOn: "12/12/2021",
        _DueTo: "02/01/2022",
        _Status: StatusTypes.INPROGRESS,
        _Sessions: [
          {
            _ID: "3",
            _StartedOn: "04/01/2022",
            _Breaks: [{ _ID: "1", _StartedAt: "45 min", _LastedFor: "15 min" }],
            _TimeWorkedOn: {
              _Hours: 0,
              _Minutes: 47,
            },
          },
        ],
      },
      {
        _ID: "6",
        _Title: "Add phonebook edit form",
        _TimeWorkedOn: {
          _Hours: 0,
          _Minutes: 47,
        },
        _CreatedOn: "19/11/2021",
        _StartedOn: "12/12/2021",
        _DueTo: "02/01/2022",
        _Status: StatusTypes.INPROGRESS,
        _Sessions: [
          {
            _ID: "3",
            _StartedOn: "04/01/2022",
            _Breaks: [{ _ID: "1", _StartedAt: "45 min", _LastedFor: "15 min" }],
            _TimeWorkedOn: {
              _Hours: 0,
              _Minutes: 47,
            },
          },
        ],
      },
      {
        _ID: "6",
        _Title: "Add phonebook edit form",
        _TimeWorkedOn: {
          _Hours: 0,
          _Minutes: 47,
        },
        _CreatedOn: "19/11/2021",
        _StartedOn: "12/12/2021",
        _DueTo: "02/01/2022",
        _Status: StatusTypes.INPROGRESS,
        _Sessions: [
          {
            _ID: "3",
            _StartedOn: "04/01/2022",
            _Breaks: [{ _ID: "1", _StartedAt: "45 min", _LastedFor: "15 min" }],
            _TimeWorkedOn: {
              _Hours: 0,
              _Minutes: 47,
            },
          },
        ],
      },
      {
        _ID: "6",
        _Title: "Add phonebook edit form",
        _TimeWorkedOn: {
          _Hours: 0,
          _Minutes: 47,
        },
        _CreatedOn: "19/11/2021",
        _StartedOn: "12/12/2021",
        _DueTo: "02/01/2022",
        _Status: StatusTypes.COMPLETED,
        _Sessions: [
          {
            _ID: "3",
            _StartedOn: "04/01/2022",
            _Breaks: [{ _ID: "1", _StartedAt: "45 min", _LastedFor: "15 min" }],
            _TimeWorkedOn: {
              _Hours: 0,
              _Minutes: 47,
            },
          },
        ],
      },
      {
        _ID: "6",
        _Title: "Add phonebook edit form",
        _TimeWorkedOn: {
          _Hours: 0,
          _Minutes: 47,
        },
        _CreatedOn: "19/11/2021",
        _StartedOn: "12/12/2021",
        _DueTo: "02/01/2022",
        _Status: StatusTypes.NOTSTARTED,
        _Sessions: [
          {
            _ID: "3",
            _StartedOn: "04/01/2022",
            _Breaks: [{ _ID: "1", _StartedAt: "45 min", _LastedFor: "15 min" }],
            _TimeWorkedOn: {
              _Hours: 0,
              _Minutes: 47,
            },
          },
        ],
      },
      {
        _ID: "6",
        _Title: "Add phonebook edit form",
        _TimeWorkedOn: {
          _Hours: 0,
          _Minutes: 47,
        },
        _CreatedOn: "19/11/2021",
        _StartedOn: "12/12/2021",
        _DueTo: "02/01/2022",
        _Status: StatusTypes.NOTSTARTED,
        _Sessions: [
          {
            _ID: "3",
            _StartedOn: "04/01/2022",
            _Breaks: [{ _ID: "1", _StartedAt: "45 min", _LastedFor: "15 min" }],
            _TimeWorkedOn: {
              _Hours: 0,
              _Minutes: 47,
            },
          },
        ],
      },
    ],
    _Progress: {
      _Percentage: 30,
      _TimeWorkedOn: {
        _Hours: 4,
        _Minutes: 42,
      },
      _Tasks: {
        _Done: 2,
        _All: 6,
      },
    },
  },
  {
    _Name: "Evidences",
    _ID: 2,
    _Type: ProjectTypes.WORK,
    _Starred: true,
    _Tasks: [
      {
        _ID: "1",
        _Title: "Implement evidences CRUD",
        _TimeWorkedOn: {
          _Hours: 2,
          _Minutes: 20,
        },
        _CreatedOn: "19/11/2021",
        _StartedOn: "12/12/2021",
        _DueTo: "02/01/2022",
        _Status: StatusTypes.NOTSTARTED,
        _Sessions: [
          {
            _ID: "1",
            _StartedOn: "04/01/2022",
            _Breaks: [{ _ID: "1", _StartedAt: "45 min", _LastedFor: "15 min" }],
            _TimeWorkedOn: {
              _Hours: 0,
              _Minutes: 45,
            },
          },
          {
            _ID: "2",
            _StartedOn: "04/01/2022",
            _Breaks: [{ _ID: "1", _StartedAt: "45 min", _LastedFor: "15 min" }],
            _TimeWorkedOn: {
              _Hours: 1,
              _Minutes: 35,
            },
          },
        ],
      },
      {
        _ID: "2",
        _Title: "Add location edit form",
        _TimeWorkedOn: {
          _Hours: 1,
          _Minutes: 45,
        },
        _CreatedOn: "19/11/2021",
        _StartedOn: "12/12/2021",
        _DueTo: "02/01/2022",
        _Status: StatusTypes.INPROGRESS,
        _Sessions: [
          {
            _ID: "5",
            _StartedOn: "04/01/2022",
            _Breaks: [{ _ID: "1", _StartedAt: "45 min", _LastedFor: "15 min" }],
            _TimeWorkedOn: {
              _Hours: 0,
              _Minutes: 45,
            },
          },
          {
            _ID: "5",
            _StartedOn: "04/01/2022",
            _Breaks: [{ _ID: "1", _StartedAt: "45 min", _LastedFor: "15 min" }],
            _TimeWorkedOn: {
              _Hours: 1,
              _Minutes: 0,
            },
          },
        ],
      },
      {
        _ID: "3",
        _Title: "Add folder like structure for location menu",
        _TimeWorkedOn: {
          _Hours: 4,
          _Minutes: 20,
        },
        _CreatedOn: "12/10/2021",
        _StartedOn: "12/12/2021",
        _DueTo: "02/01/2022",
        _Status: StatusTypes.COMPLETED,
        _Sessions: [
          {
            _ID: "6",
            _StartedOn: "04/01/2022",
            _Breaks: [{ _ID: "1", _StartedAt: "45 min", _LastedFor: "15 min" }],
            _TimeWorkedOn: {
              _Hours: 1,
              _Minutes: 0,
            },
          },
          {
            _ID: "6",
            _StartedOn: "04/01/2022",
            _Breaks: [{ _ID: "1", _StartedAt: "45 min", _LastedFor: "15 min" }],
            _TimeWorkedOn: {
              _Hours: 2,
              _Minutes: 20,
            },
          },
          {
            _ID: "6",
            _StartedOn: "04/01/2022",
            _Breaks: [{ _ID: "1", _StartedAt: "45 min", _LastedFor: "15 min" }],
            _TimeWorkedOn: {
              _Hours: 2,
              _Minutes: 0,
            },
          },
        ],
      },
      {
        _ID: "4",
        _Title: "Implement add location form",
        _TimeWorkedOn: {
          _Hours: 0,
          _Minutes: 0,
        },
        _CreatedOn: "19/11/2021",
        _StartedOn: "12/12/2021",
        _DueTo: "02/01/2022",
        _Status: StatusTypes.NOTSTARTED,
        _Sessions: [
          
        ],
      },
    ],
    _Progress: {
      _Percentage: 25,
      _TimeWorkedOn: {
        _Hours: 8,
        _Minutes: 25,
      },
      _Tasks: {
        _Done: 1,
        _All: 4,
      },
    },
  },
  {
    _Name: "Workon",
    _ID: 3,
    _Type: ProjectTypes.SCHOOL,
    _Starred: false,
    _Tasks: [
      {
        _ID: "1",
        _Title: "Implement Tasks CRUD",
        _TimeWorkedOn: {
          _Hours: 5,
          _Minutes: 40,
        },
        _CreatedOn: "19/11/2021",
        _StartedOn: "12/12/2021",
        _DueTo: "02/01/2022",
        _Status: StatusTypes.INPROGRESS,
        _Sessions: [
          {
            _ID: "7",
            _StartedOn: "04/01/2022",
            _Breaks: [{ _ID: "1", _StartedAt: "45 min", _LastedFor: "15 min" }],
            _TimeWorkedOn: {
              _Hours: 1,
              _Minutes: 5,
            },
          },
          {
            _ID: "8",
            _StartedOn: "04/01/2022",
            _Breaks: [{ _ID: "1", _StartedAt: "45 min", _LastedFor: "15 min" }],
            _TimeWorkedOn: {
              _Hours: 0,
              _Minutes: 55,
            },
          },
          {
            _ID: "9",
            _StartedOn: "04/01/2022",
            _Breaks: [{ _ID: "1", _StartedAt: "45 min", _LastedFor: "15 min" }],
            _TimeWorkedOn: {
              _Hours: 2,
              _Minutes: 0,
            },
          },
          {
            _ID: "10",
            _StartedOn: "04/01/2022",
            _Breaks: [{ _ID: "1", _StartedAt: "45 min", _LastedFor: "15 min" }],
            _TimeWorkedOn: {
              _Hours: 1,
              _Minutes: 40,
            },
          },
        ],
      },
      {
        _ID: "2",
        _Title: "Complete Task form logic",
        _TimeWorkedOn: {
          _Hours: 2,
          _Minutes: 50,
        },
        _CreatedOn: "19/11/2021",
        _StartedOn: "12/12/2021",
        _DueTo: "02/01/2022",
        _Status: StatusTypes.INPROGRESS,
        _Sessions: [
          {
            _ID: "8",
            _StartedOn: "04/01/2022",
            _Breaks: [{ _ID: "1", _StartedAt: "45 min", _LastedFor: "15 min" }],
            _TimeWorkedOn: {
              _Hours: 1,
              _Minutes: 12,
            },
          },
        ],
      },
      {
        _ID: "3",
        _Title: "Add login authentication",
        _TimeWorkedOn: {
          _Hours: 0,
          _Minutes: 10,
        },
        _CreatedOn: "19/11/2021",
        _StartedOn: "12/12/2021",
        _DueTo: "02/01/2022",
        _Status: StatusTypes.NOTSTARTED,
        _Sessions: [
          {
            _ID: "9",
            _StartedOn: "04/01/2022",
            _Breaks: [{ _ID: "1", _StartedAt: "45 min", _LastedFor: "15 min" }],
            _TimeWorkedOn: {
              _Hours: 1,
              _Minutes: 12,
            },
          },
        ],
      },
    ],
    _Progress: {
      _Percentage: 0,
      _TimeWorkedOn: {
        _Hours: 8,
        _Minutes: 40,
      },
      _Tasks: {
        _Done: 0,
        _All: 3,
      },
    },
  },

  {
    _Name: "Grab and Go",
    _ID: 4,
    _Type: ProjectTypes.PERSONAL,
    _Starred: false,
    _Tasks: [
      {
        _ID: "1",
        _Title: "Add store data",
        _TimeWorkedOn: {
          _Hours: 2,
          _Minutes: 20,
        },
        _CreatedOn: "12/05/2021",
        _StartedOn: "19/05/2021",
        _DueTo: "19/09/2021",
        _Status: StatusTypes.INPROGRESS,
        _Sessions: [
          {
            _ID: "10",
            _StartedOn: "04/01/2022",
            _Breaks: [{ _ID: "1", _StartedAt: "45 min", _LastedFor: "15 min" }],
            _TimeWorkedOn: {
              _Hours: 2,
              _Minutes: 20,
            },
          },
        ],
      },
      {
        _ID: "2",
        _Title: "Complete login form design",
        _TimeWorkedOn: {
          _Hours: 1,
          _Minutes: 30,
        },
        _CreatedOn: "19/11/2021",
        _StartedOn: "12/12/2021",
        _DueTo: "02/01/2022",
        _Status: StatusTypes.INPROGRESS,
        _Sessions: [
          {
            _ID: "11",
            _StartedOn: "04/01/2022",
            _Breaks: [{ _ID: "1", _StartedAt: "45 min", _LastedFor: "15 min" }],
            _TimeWorkedOn: {
              _Hours: 1,
              _Minutes: 0,
            },
          },
          {
            _ID: "12",
            _StartedOn: "04/01/2022",
            _Breaks: [{ _ID: "1", _StartedAt: "45 min", _LastedFor: "15 min" }],
            _TimeWorkedOn: {
              _Hours: 0,
              _Minutes: 30,
            },
          },
          {
            _ID: "11",
            _StartedOn: "04/01/2022",
            _Breaks: [{ _ID: "1", _StartedAt: "45 min", _LastedFor: "15 min" }],
            _TimeWorkedOn: {
              _Hours: 1,
              _Minutes: 12,
            },
          },
        ],
      },
      {
        _ID: "3",
        _Title: "Add login authentication",
        _TimeWorkedOn: {
          _Hours: 0,
          _Minutes: 10,
        },
        _CreatedOn: "19/11/2021",
        _StartedOn: "12/12/2021",
        _DueTo: "02/01/2022",
        _Status: StatusTypes.COMPLETED,
        _Sessions: [
          {
            _ID: "12",
            _StartedOn: "04/01/2022",
            _Breaks: [{ _ID: "1", _StartedAt: "45 min", _LastedFor: "15 min" }],
            _TimeWorkedOn: {
              _Hours: 1,
              _Minutes: 12,
            },
          },
        ],
      },
      {
        _ID: "4",
        _Title: "Add navigation bar",
        _TimeWorkedOn: {
          _Hours: 0,
          _Minutes: 50,
        },
        _CreatedOn: "19/11/2021",
        _StartedOn: "12/12/2021",
        _DueTo: "02/01/2022",
        _Status: StatusTypes.COMPLETED,
        _Sessions: [
          {
            _ID: "12",
            _StartedOn: "04/01/2022",
            _Breaks: [{ _ID: "1", _StartedAt: "45 min", _LastedFor: "15 min" }],
            _TimeWorkedOn: {
              _Hours: 0,
              _Minutes: 50,
            },
          },
        ],
      },
    ],
    _Progress: {
      _Percentage: 50,
      _TimeWorkedOn: {
        _Hours: 4,
        _Minutes: 0,
      },
      _Tasks: {
        _Done: 2,
        _All: 4,
      },
    },
  },
];
